import { Typography, Box, useTheme, TextField, Divider, Autocomplete, Button, Grid, Dialog, Tooltip, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CallAlertBar from "../../Layout/Alertbar";
import { tokens } from "../../theme/theme";
import { callApi } from "../../utils/apiClient";
import { API_ENDPOINTS } from "../../config/api/apiCall";
import useMaterialCategory from "../../hooks/useMaterialCategory";
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import DeleteForeverIcon from '@mui/icons-material/HighlightOff';
import useMaterialSubCategory from "../../hooks/useMaterialSubCategory";
const AddSubCategory = ({ onClose, handleBackWinderMachineEntry, open }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [result, setresult] = useState([]);
    const [selectedSubCategoryNew, setSelectedSubCategoryNew] = useState(null);
    //message are 
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

    const CategoryColumns = [
        {
            field: 'sno',
            headerName: 'S.No',
            width: 80,
            sortable: false,
            filterable: false,
            renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
        },
        {
            field: "category_description",
            headerName: "Category",
            flex: 1,
            cellClassName: "name-column--cell"

        },
        {
            field: "description",
            headerName: "Sub Category",
            flex: 1,
            cellClassName: "name-column--cell"

        },
        {
            field: "actions",
            headerName: "Actions",
            width: 100,
            sortable: false,
            filterable: false,
            renderCell: (params) => (


                <Tooltip title="Delete Material Sub Category">
                    <IconButton
                        color="error"

                        onClick={() => handleAddDeleteSubCategory('DELETE', params.row.id_material_subcategory)}
                    >
                        <DeleteForeverIcon style={{ fontSize: '22px' }} />
                    </IconButton></Tooltip>
            )
        }
    ];

    const { materialCategory, selectedCategory, selectedCategoryID, setSelectedCategory, setSelectedCategoryID, loadMaterialCategoryByID } = useMaterialCategory(0);
    const { materialSubCategory, selectedSubCategory, selectedSubCategoryID, setSelectedSubCategory, setSelectedSubCategoryID, loadMaterialSubCategoryByID } = useMaterialSubCategory(0);




    const handleAddDeleteSubCategory = (mode, subCategoryId) => {
        setParentRollMsgOpen(false);

        if (mode === 'DELETE') {
            if (window.confirm("Are you sure you want to delete this category?")) {
                // If user confirms, proceed with deletion
                setSelectedSubCategoryNew(null);
            }
            else {
                // If user cancels, exit the function
                return;
            }
        }

        // validation
        let isValid = true;
        let validation_msg = '';

        if (selectedSubCategoryNew === '') {
            validation_msg += 'Please enter the sub category description.\n';
            isValid = false;
        }

        if (selectedCategoryID === 0 || selectedCategoryID === undefined) {
            validation_msg += 'Please select the category.\n';
            isValid = false;
        }

        if (isValid) {
            const SaveData = {
                p_db_mode: mode,  // required for backend to know operation
                p_companyid: parseInt(localStorage.getItem('companyid')),
                p_plantid: 1,
                p_id_category: selectedCategoryID,   // assuming you have this from dropdown or props
                p_subcategory: selectedSubCategoryNew || '',  // new sub category name
                p_subcategoryid: subCategoryId || null  // not needed for ADD
            };

            callApi(API_ENDPOINTS.MATERIAL_SUB_CATEGORY_CRUD, 'POST', { 'Content-Type': 'application/json' }, SaveData)
                .then(data => {
                    if (data && data.length > 0) {
                        setresult(data[0]);

                        if (data[0].result_value === 0) {
                            const action = mode === 'ADD' ? 'added' : 'deleted';
                            toast.success(`Sub Category ${action} successfully.`, { position: toast.POSITION.BOTTOM_CENTER });
                            loadMaterialSubCategoryByID(selectedCategoryID);  // reload with current category
                            
                        }
                        else if (data[0].result_value === 1) {
                            const message = mode === 'ADD'
                                ? 'Sub Category already exists.'
                                : 'Sub Category not found.';
                            toast.error(message, { position: toast.POSITION.BOTTOM_CENTER });
                        }
                        else if (data[0].result_value === 2) {
                            toast.error('Parent Category does not exist.', { position: toast.POSITION.BOTTOM_CENTER });
                        }
                        else if (data[0].result_value === -1) {
                            toast.error('Invalid Mode Specified.', { position: toast.POSITION.BOTTOM_CENTER });
                        }

                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        } else {
            setParentRollSeverityvalue('warning');
            setParentRollMessageValue(validation_msg);
            setParentRollAlertTitleValue('info');
            setParentRollMsgOpen(true);
        }
    };


    return (

        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                style: {
                    alignSelf: 'flex-start',
                    margin: '0 auto',
                    position: 'relative',
                    top: '0px',
                },
            }}
            BackdropProps={{
                style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    paddingTop: '20px',
                    minHeight: '100vh',
                    background: 'rgba(0,0,0,0.5)',
                },
            }}
        >


            <DialogTitle style={{ backgroundColor: colors.primary[600], color: colors.primary }}>
                <Box display="flex" alignItems="center">
                    {/* <WarningRoundedIcon style={{ marginRight: 8, color: 'pink', fontSize: "32" }} /> Add icon with some margin */}
                    <Typography>Add Sub Cateogry</Typography>
                </Box>

            </DialogTitle>
            <DialogContent style={{ backgroundColor: colors.primary[500], color: colors.primary }}>
                {/* Your modal content here */}


                <Box>
                    {/* <Header title="Add New Operator" subtitle="" callback={onClose} />
                        <Divider /> */}
                    {/* Message box detail */}
                    <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


                    <Grid container spacing={2} sx={{ width: '100%', p: 0.5 }} >
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >


                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={1}
                                marginBottom={5}
                            >


                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 3',
                                        xl: 'span 3',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <Typography variant="h6"> Category </Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 9',
                                        xl: 'span 9',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >

                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        options={materialCategory}
                                        value={selectedCategory}
                                        onChange={(event, newValue) => {
                                            setSelectedCategory(newValue);
                                            setSelectedCategoryID(newValue?.id_material_category || null);
                                            if (newValue) {

                                                loadMaterialSubCategoryByID(newValue.id_material_category);
                                            }
                                        }}
                                        getOptionLabel={(option) => option.description || ''}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Select Category" required variant="outlined" color="secondary" />
                                        )}
                                    />


                                </Box>
                            </Box>

                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={1}
                            >
                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 3',
                                        xl: 'span 3',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <Typography variant="h6"> Sub Category  </Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 9',
                                        xl: 'span 9',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <TextField label='Enter the Sub Category' value={selectedSubCategoryNew} color="secondary" onChange={(e) => setSelectedSubCategoryNew(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dot', } } }} fullWidth size="small" type="text" ></TextField>
                                </Box>
                            </Box>

                            <Box marginTop={5}>
                                <Box display="flex" justifyContent="flex-end">
                                    <Button onClick={() => handleAddDeleteSubCategory('ADD', null)} size="small" variant="contained" color="secondary">
                                        Add
                                    </Button>
                                    {/* <Button size="small" sx={{ marginLeft: "10px" }} variant="contained" onClick={onClose} color="secondary">
                                        Cancel
                                    </Button> */}
                                </Box>
                            </Box>


                            {/* 
                                </CardContent>
                            </Card> */}

                            <Divider sx={{ marginTop: '20px' }} />


                            <Box marginTop={1}>
                                <Typography variant="h6" sx={{ marginTop: '10px', marginBottom: '10px' }}> Category List</Typography>

                                <Box

                                    gridColumn="span 9"
                                    gridRow={"span 2"}
                                    alignItems="center"
                                    justifyContent="center"

                                    height="51vh"
                                    sx={{

                                        "& .MuiCheckbox-root": {
                                            color: `${colors.greenAccent[200]} !important`,
                                        },
                                        "& .Muidropdown-root": {
                                            color: `${colors.greenAccent[200]} !important`,
                                        },

                                        borderLeft: "0", // Remove left border
                                        borderRight: "0", // Remove right border
                                    }}
                                >
                                    <DataGrid name="dgv-orderselection" getRowId={(row) => row.id_material_subcategory} pageSize={5} columnHeaderHeight={35} rowHeight={40} rows={materialSubCategory} columns={CategoryColumns}


                                    />

                                </Box>
                            </Box>

                        </Grid>
                    </Grid>
                </Box>

            </DialogContent>
            <DialogActions style={{ backgroundColor: colors.primary[400] }}>
                <Button size='small' onClick={onClose} variant="contained" color="secondary" style={{ textTransform: 'none' }} >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default AddSubCategory;